import axios from 'axios';

const getUserInfo = async (token) => {
  try {
    const res = await axios.get('/Auth_private/my_info', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getUserInfo;
